import {register} from "swiper/element/bundle";
import localFont from 'next/font/local';
import "../assets/styles/icons.css";
import "../assets/styles/globals.css";
import {useEffect, useRef, useState} from "react";
import {useRouter} from "next/router";
import {ErrorHandlerLayout, MainLayout} from "@/layouts";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Provider} from "react-redux";
import {store} from "@/redux/store/store";
import {GoogleOAuthProvider} from '@react-oauth/google';
import {VerifyCookie} from "@/components";
import Script from "next/script";

register();

const yekanBakh = localFont({
    src: '../assets/fonts/YekanBakhFaNum-VF.woff2',
    variable: '--font-yekanbakh',
    display: "swap"
})

export default function MyApp({Component, pageProps: {session, ...pageProps}}) {

    const [verifiedCookie, setVerifiedCookie] = useState(true);
    const goToTopRef = useRef(null);
    const router = useRouter();

    // console.log("session", session);

    useEffect(() => {
        document.addEventListener('contextmenu', event => event.preventDefault());
        if (!!!localStorage.getItem("verify_cookie")) {
            setVerifiedCookie(false);
        }
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", onScroll);

        return () => {
            window.removeEventListener("scroll", onScroll);
        }

    }, [router.pathname]);

    const onScroll = () => {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            goToTopRef.current.style.display = "block";
        } else {
            goToTopRef.current.style.display = "none";
        }
    }

    const goToTop = () => {
        try {
            window.scrollTo({top: 0, behavior: 'smooth'});
        } catch (e) {

        }
    }

    const verifyCookieHandler = () => {
        localStorage.setItem("verify_cookie", "true");
        setVerifiedCookie(true);
    }

    return (
        <>
            <style jsx global>{`
              html {
                font-family: ${yekanBakh.style.fontFamily};
              }

              .Toastify__toast .Toastify__toast-body {
                font-family: ${yekanBakh.style.fontFamily};
              }
            `}</style>
            <Script id="google-analytics" strategy="afterInteractive">
                {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-WTGNKP2P');`}
            </Script>
            <Script id="najva">
                {`(function(){
               var now = new Date();
               var version = now.getFullYear().toString() + "0" + now.getMonth() + "0" + now.getDate() +
                   "0" + now.getHours();
               var head = document.getElementsByTagName("head")[0];
               var link = document.createElement("link");
               link.rel = "stylesheet";
               link.href = "https://van.najva.com/static/cdn/css/local-messaging.css" + "?v=" + version;
               head.appendChild(link);
               var script = document.createElement("script");
               script.type = "text/javascript";
               script.async = true;
               script.src = "https://van.najva.com/static/js/scripts/poldesigners-website-21972-a263b328-9fc7-4ff1-83a4-719be2350ee4.js" + "?v=" + version;
               head.appendChild(script);
           })()`}
            </Script>
            <ToastContainer hideProgressBar limit={3} theme='colored'/>
            <Provider store={store}>
                <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>
                    <ErrorHandlerLayout pageProps={pageProps}>
                        <main>
                            <MainLayout/>
                            <Component {...pageProps} />
                            {
                                verifiedCookie ? null :
                                    <VerifyCookie onVerify={verifyCookieHandler}/>
                            }
                            <div className="fixed right-0 bottom-7 z-[100] w-full pointer-events-none">
                                <div className="container xl:!px-16 lg:!px-10 !px-3.5">
                                    <button
                                        id="go-to-top"
                                        style={{display: "none"}}
                                        ref={goToTopRef}
                                        onClick={goToTop}
                                        className="pointer-events-auto w-[3.125rem] h-[3.125rem] bg-pol-blue-light rounded-2xl shadow-[0_6px_12px_4px_rgba(96,55,229,0.3)]">
                                        <i className="icon-simple-arrow-left inline-block rotate-90 text-pol-blue"/>
                                    </button>
                                </div>
                            </div>
                        </main>
                    </ErrorHandlerLayout>
                </GoogleOAuthProvider>
            </Provider>
        </>
    )
}

